import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {
  detailDeveloper,
  detailEditDeveloper,
} from "../../actions/developerAction";
import CreatableSelect from "react-select/creatable";
import DevWelcome from "../../components/DevWelcome";
import DevMenu from "../../components/DevMenu";
import RightDash from "../../components/RightDash";
import { skillsdata } from "../../data/skillsdata";
import Message from "../../components/Message";
import Login from "../Login";
import Signout from "../../components/Signout";
import "../../styles/dashboard.css";

import { Upload, message } from "antd";
import { InboxOutlined } from "@ant-design/icons";

const { Dragger } = Upload;

const DeveloperProfile = ({ history, resizeMenu, setResizeMenu }) => {
  const [skill, setSkill] = useState("");
  const [expertValue, setExpertValue] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [bio, setBio] = useState("");
  const [github, setGithub] = useState("");
  const [cv, setCv] = useState("");
  const [skillslevel, setSkillslevelValue] = useState("");
  const [skills, setSkills] = useState([]);

  const [fileList, setFileList] = useState([]);
  const [cloudList, setCloudList] = useState([]);

  const dispatch = useDispatch();

  const developerDetail = useSelector((state) => state.developerDetail);

  const { devDetail, error, loading } = developerDetail;

  const developerDetailEdit = useSelector((state) => state.developerDetailEdit);

  const {
    devDetail: devEdit,
    error: editerror,
    loading: editloading,
  } = developerDetailEdit;

  useEffect(() => {
    dispatch(detailDeveloper());
  }, [detailDeveloper]);

  useEffect(() => {
    if (
      devDetail !== undefined &&
      devDetail !== null &&
      Object.keys(devDetail).length
    ) {
      setName(devDetail.user.name);
      setEmail(devDetail.user.email);
      setBio(devDetail.bio);
      setSkillslevelValue(devDetail.skillslevel);
      setGithub(devDetail.github);
      setCv(devDetail.cv);
      setSkills(devDetail.skills);
    }
  }, [devDetail]);

  const handleSelect = (newValue, actionMeta) => {
    let skillArr = newValue.map((item) => {
      return item.value;
    });
    setSkills(skillArr);
  };

  const handleChange = (info) => {
    let fileList = [...info.fileList];

    // 1. Limit the number of uploaded files
    // Only to show two recent uploaded files, and old ones will be replaced by the new
    fileList = fileList.slice(-1);

    // 2. Read from response and show file link
    fileList = fileList.map((file) => {
      if (file.response) {
        // Component will show file.url as link
        file.url = file.response.url;
      }
      return file;
    });

    setFileList(fileList);
  };

  const dummyRequest = ({ file, onSuccess }) => {
    const image = new FormData();
    image.append("upload_preset", "fz0bvgt7");
    image.append("file", file);
    const config = {
      headers: { "X-Requested-With": "XMLHttpRequest" },
    };
    axios
      .post("https://api.cloudinary.com/v1_1/teqporte/upload", image, config)
      .then((res) => {
        const secureUrl = res.data.secure_url;
        const newList = [secureUrl];
        setCloudList(newList);
        setCv(newList);
      });
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  const userLogin = useSelector((state) => state.userLogin);

  const { userInfo } = userLogin;

  if (!userInfo) {
    return <Login />;
  }

  if (userInfo && userInfo.role === "employer") {
    history.push("/employer/dashboard");
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!skills.length) {
      return message.error("Expertise field is required");
    }
    dispatch(
      detailEditDeveloper(
        name,
        email,
        skills,
        skillslevel,
        bio,
        cv,
        github,
        history
      )
    );
    // dispatch(detailDeveloper());
  };

  return (
    <div className="dashboard">
      <DevMenu resizeMenu={resizeMenu} setResizeMenu={setResizeMenu} />
      <RightDash resizeMenu={resizeMenu} setResizeMenu={setResizeMenu}>
        {devEdit && (
          <Message variant="success">Profile edit successful</Message>
        )}
        {editerror && <Message variant="danger">{editerror}</Message>}
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100 h-100">
            <div className="spinner-blue"></div>
          </div>
        ) : error ? (
          <Message variant="danger">
            {error} <a href="/developer/jobs">refresh page</a>
          </Message>
        ) : (
          <div className="right-wrapper">
            <DevWelcome />
            <div className="main p-3">
              <div>
                <h4 className="font-medium mb-2">Personal Information</h4>
                <div className="form-wrapper">
                  <form onSubmit={handleSubmit}>
                    <div className="mb-1">
                      <label className="mb-25  font-normal d-inline-block">Fullname</label>
                      <div className="dashinput">
                        <input
                          type="text"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    <div className="mb-1">
                      <label className="mb-25  font-normal d-inline-block">
                        Email Address
                      </label>
                      <div className="dashinput">
                        <input
                          type="email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    <div className="mb-1">
                      <label className="mb-25  font-normal d-inline-block">Expertise</label>
                      <div className="dashinput">
                        <CreatableSelect
                          isMulti
                          name="skill"
                          options={skillsdata}
                          onChange={handleSelect}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          placeholder="e.g. react, java, python"
                          required
                        />
                        <p className="mb-25 text-black-fade">
                          {skills && skills.join(", ")}
                        </p>
                      </div>
                    </div>
                    <div className="mb-1">
                      <label className="mb-25  font-normal d-inline-block">
                        Expertise Level
                      </label>
                      <div className="dashinput">
                        <select
                          className="select"
                          value={skillslevel}
                          onChange={(e) => {
                            setSkillslevelValue(e.target.value);
                          }}
                          required>
                          <option value="beginner">Beginner (0-3years)</option>
                          <option value="intermediate">
                            Intermediate (3-5years)
                          </option>
                          <option value="expert">Expert (5+)</option>
                        </select>
                      </div>
                    </div>
                    <div className="mb-1">
                      <label className="mb-25  font-normal d-inline-block">About you</label>
                      <div className="dashinput">
                        <p className="mb-25">Little bio about you</p>
                        <textarea
                          rows="10"
                          value={bio}
                          onChange={(e) => setBio(e.target.value)}
                          required></textarea>
                      </div>
                    </div>
                    <div className="mb-1">
                      <label className="mb-25  font-normal d-inline-block">CV</label>
                      <div className="dashinput">
                        <Dragger
                          fileList={fileList}
                          onChange={handleChange}
                          customRequest={dummyRequest}>
                          <p>
                            <InboxOutlined />
                          </p>
                          <p className="ant-upload-text">
                            Click or drag file to this area to upload
                          </p>
                        </Dragger>
                        <p className="mb-25 text-black-fade">
                          {cv && (
                            <a
                              target="_blank"
                              rel="noreferrer"
                              href={cv && cv.slice(0, 1).join(", ")}>
                              CV
                            </a>
                          )}
                        </p>
                      </div>
                    </div>
                    <div className="mb-1">
                      <label className="mb-25  font-normal d-inline-block">Github</label>
                      <div className="dashinput">
                        <input
                          type="text"
                          name="github"
                          placeholder="e.g. petrepan"
                          value={github}
                          onChange={(e) => setGithub(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    <div className="my-2">
                      <button
                        className="d-flex justify-content-center button"
                        type="submit">
                        {editloading ? (
                          <div className="spinner"></div>
                        ) : (
                          "SUBMIT"
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        )}
      </RightDash>
    </div>
  );
};

export default DeveloperProfile;
